import { Branding, BrandingDisabledIf, DisabledPrompt, NavLink, useModel, useRoute, BrandingStyle } from "bcms-react";
import Util from "classes/Util";
import CustomAccordion, { CustomAccordionContent, CustomAccordionToggle } from 'components/custom-ui/CustomAccordion';
import CustomDrawer, { CustomDrawerContent, CustomDrawerFooter, CustomDrawerHeader } from 'components/custom-ui/CustomDrawer';
import { ModalSecondaryButton } from 'components/custom-ui/CustomModal';
import React, { useEffect, useState } from 'react';
import { SVGAsset } from 'res';
import { UtilityNavBadge } from '../UtilityNavView';
import { Profile } from "model";
import BID1224MobileNavItems from "./customMenuViews/BID1224MobileNavItems";
import "./styles.css";
import BID126MobileNavItems from "./customMenuViews/BID126MobileNavItems";
import BID932MobileNavItems from "./customMenuViews/BID932MobileNavItems";
import BID932UtilityNavMenuItems from "../UtilityNavView/customUtilityNavItems/BID126UtilityNavMenuItems";
import BID2132PMobileNavItems from "./customMenuViews/BID2132PMobileNavItems";
import BID2132BMobileNavItems from "./customMenuViews/BID2132BMobileNavItems";
import BID1225BMobileNavItems from "./customMenuViews/BID1225BMobileNavItems";
import BID1225PMobileNavItems from "./customMenuViews/BID1225PMobileNavItems";

const MobileNavViewContext = React.createContext(null);

/**
 * @function MobileNavView
 * @extends React.Component
 * @exported true
 * @description The main component for the navigation on mobile.
 * @note 
 * - This component combines the links from the MainNavView and the UtilityNavView and is only shown on mobile.
 * - This is used as a modal, using the CustomDrawer component. To open it you will use ModalOpen id="MobileNavView".
 * @example
 * <ModalOpen id="MobileNavView">
 *  <button>Open Menu</button>
 * </ModalOpen>
 */
export default function MobileNavView(props) {
  const { user, demos, branding } = useModel();
  const navigate = useRoute();
  const mabi23Branding = window.mabi23Branding;
  const mabi23BrandingOptions = mabi23Branding ? mabi23Branding.options : {};
  const [ visible, setVisible ] = useState("");
  const username = `${ user.first } ${ user.last }`;
  const logout = ()=>{
    if(Util.inMabi){
      Util.routeMabi("login")
  }else{
    navigate("/login")
  }
}

  const options = useModel().branding.options;
  const paymentsLabel = options.payments_label_abi22.length ? options.payments_label_abi22 : "Payments";
  const chatLink = () =>{
    if(Util.inMabi) {
       Util.openMabiChat()
      }
      else {
        window.open(window.location.href.slice(0, window.location.href.indexOf("#")) + "#/chat", "_blank")
      }
  
    };

  const openAccount = evt => {
    if(Util.inMabi) {
      window.parent.postMessage({ message:"force-global-route", detail: {
          route: `/content/orig`
      }   
      }, "*");
    } else {
      let origVersion = branding.options.orig_version_abi22;
      if(origVersion !== "ORIG19") origVersion = "ORIG20";
      window.open(demos[origVersion], "_blank");
    }
  }

  const onCardsClick = evt => {
    if(Util.inMabi) {
      Util.openABI22StandaloneOverlayInMABI23();
     } else {
      navigate("/ch21");
     }
  }
  let newAccountsItem =  <MobileNavDropdownMenuItem className="accounts-mobile-link" itemIcon={<SVGAsset id="WalletIcon" />} label="Accounts" dataPoint="Nav_Accounts">

  <MobileNavMenuItem className="account-summary-mobile-link" to="/accountSummary" label="Account Summary" dataPoint="Nav_Account_Summary" />
  <MobileNavMenuItem className="epreference-mobile-link" label="ePreference" to="/statementPreference" dataPoint="Nav_ePreference" />
  <Branding id="open_account_abi22" value="true">
    <BrandingDisabledIf id="orig_courseid_abi22" exp={ value => {  return value !== null && value !== undefined; } }>
      <MobileNavMenuItem className="open-an-account-mobile-link" label="Open an Account" dataPoint="Nav_Open_Account" onClick={ openAccount } />
    </BrandingDisabledIf>
  </Branding>
  <Branding id="cs21_abi22" value="true">
    <BrandingDisabledIf id="cs21_courseID_abi22" exp={ value => value !== null }>
      <MobileNavMenuItem className="credit-score-mobile-link" label="Credit Score" to="/creditScore" dataPoint="Nav_Credit_Score" />
    </BrandingDisabledIf>
  </Branding>

  <Branding id="stop_payments_abi22" value="true">
    <MobileNavMenuItem className="stop-payments-mobile-link" to="/stopPayment" label="Stop Payments" dataPoint="Nav_Stop_Payments" />
  </Branding>
  {/* <Branding id="download_abi22" value="true">
    <MobileNavMenuItem to="/download" label="Download" dataPoint="Nav_Download" />
  </Branding> */}
  <MobileNavMenuItem className="estatement-mobile-link" label="E-Statements & Notices" to="/statements" dataPoint="Nav_eStatements_Noticies" />

</MobileNavDropdownMenuItem>
 let accountsItem =  <MobileNavDropdownMenuItem className="accounts-mobile-link" itemIcon={<SVGAsset id="WalletIcon" />} label="Accounts" dataPoint="Nav_Accounts">

  <MobileNavMenuItem className="account-summary-mobile-link" to="/accountSummary" label="Account Summary" dataPoint="Nav_Account_Summary" />
  <MobileNavMenuItem className="epreference-mobile-link" label="ePreference" to="/statementPreference" dataPoint="Nav_ePreference" />
  <Branding id="open_account_abi22" value="true">
    <BrandingDisabledIf id="orig_courseid_abi22" exp={ value => {  return value !== null && value !== undefined; } }>
      <MobileNavMenuItem className="open-an-account-mobile-link" label="Open an Account" dataPoint="Nav_Open_Account" onClick={ openAccount } />
    </BrandingDisabledIf>
  </Branding>
  <Branding id="cs21_abi22" value="true">
    <BrandingDisabledIf id="cs21_courseID_abi22" exp={ value => value !== null }>
      <MobileNavMenuItem className="credit-score-mobile-link" label="Credit Score" to="/creditScore" dataPoint="Nav_Credit_Score" />
    </BrandingDisabledIf>
  </Branding>

  <Branding id="stop_payments_abi22" value="true">
    <MobileNavMenuItem className="stop-payments-mobile-link" to="/stopPayment" label="Stop Payments" dataPoint="Nav_Stop_Payments" />
  </Branding>
  {/* <Branding id="download_abi22" value="true">
    <MobileNavMenuItem to="/download" label="Download" dataPoint="Nav_Download" />
  </Branding> */}
  <MobileNavMenuItem className="estatement-mobile-link" label="E-Statements & Notices" to="/statements" dataPoint="Nav_eStatements_Noticies" />
  
</MobileNavDropdownMenuItem>

let documentsItem = <MobileNavDropdownMenuItem className="documents-mobile-link" itemIcon={<SVGAsset id="CheckListIcon" />} label="Documents" dataPoint="Nav_Documents">
                      <Branding id="statements_abi22" value="true">
                        <MobileNavMenuItem className="statements-mobile-link" to="/statements" label="Statements" dataPoint="Nav_Statements" />
                      </Branding>
                      <DisabledPrompt>
                        <MobileNavMenuItem className="notices-mobile-link" to="/notices" label="Notices" dataPoint="Nav_Notices" />
                      </DisabledPrompt>
                      <MobileNavMenuItem className="enrollment-mobile-link" to="/enrollment" label="Enrollment" dataPoint="Nav_Enrollment" />
                      </MobileNavDropdownMenuItem> 

  let achItem = <Branding id="ach_abi22" value="true">
                  <MobileNavDropdownMenuItem className="ach-mobile-link" itemIcon={<SVGAsset id="BankIcon" />} label="ACH" dataPoint="Nav_ACH">
                    <Branding id="ach_participants_abi22" value="true">
                      <MobileNavMenuItem className="ach-participants-mobile-link" to="/achParticipants" label="ACH Participants" dataPoint="Nav_ACH_Participants" />
                    </Branding>
                    <Branding id="one_time_ach_abi22" value="true">
                    
                        <MobileNavMenuItem className="one-time-ach-mobile-link" to="/oneTimeACHWorkflow" label="One-Time ACH Payment" dataPoint="Nav_One-Time_ACH_Payment" />
                   
                    </Branding>
                    <Branding id="ach_templates_abi22" value="true">
                      <MobileNavMenuItem className="ach-templates-mobile-link" to="/achTemplates" label="ACH Templates" dataPoint="Nav_ACH_Templates" />
                    </Branding>
                    <Branding id="ach_activity_abi22" value="true">
                      <MobileNavMenuItem className="ach-activity-mobile-link" to="/achActivity" label="ACH Activity" dataPoint="Nav_ACH_Activity" />
                    </Branding>
                    <Branding id="ach_pass_thru_abi22" value="true">
                        <MobileNavMenuItem className="ach-pass-thru-mobile-link" to="/achPassthru" label="ACH Pass-Thru" dataPoint="Nav_ACH_Pass-Thru" />
                    </Branding>
                    <Branding id="ach_import_abi22" value="true">
                        <MobileNavSubDropdownMenuItem className="ach-import-mobile-link" label="Import File" dataPoint="Nav_Import" >
                          <MobileNavMenuItem className="participants-and-nacha-mobile-link" label="Participants And NACHA" to="/achImport" data-point="Nav_Participants_And_NACHA" />
                          <MobileNavMenuItem className="ach-import-mobile-link" label="Non-NACHA" to="/nonNachaFileImportWorkflow" data-point="Nav_Non_NACHA" />
                        </MobileNavSubDropdownMenuItem>
                    </Branding>
                    <Branding id="state_tax_ids_abi22" value="true">
                        <MobileNavMenuItem className="state-tax-mobile-link" to="/stateTaxIDPage" label="State Tax IDs" dataPoint="Nav_State_Tax_IDs" />
                    </Branding>
                    <Branding id="deny_users_abi22" value="true">
                        <MobileNavMenuItem className="deny-users-mobile-link" to="/denyUsers" label="Deny Users" dataPoint="Nav_Deny_Users" />
                    </Branding>
                  </MobileNavDropdownMenuItem>
                </Branding>
  
  let wireLinks = <Branding id="wires_abi22" value="true">
    <MobileNavDropdownMenuItem label="Wires" itemIcon={<SVGAsset id="WiresIcon" />} data-point="Nav_Wires">
      <Branding id="wire_payees_abi22" value="true">
        <MobileNavMenuItem className="wire-payees-mobile-link" to="/wireAddPayeeWorkflow" label="Wire Payees" dataPoint="Nav_Wire_Payees" />
      </Branding>
      <Branding id="single_wire_abi22" value="true">
        <MobileNavMenuItem className="single-wire-mobile-link" to="/singleWire" label="Single Wire" dataPoint="Nav_Single_Wire" />
      </Branding>
      <Branding id="multiple_wires_abi22" value="true">
        <MobileNavMenuItem className="multiple-wires-mobile-link" to="/multipleWires" label="Multiple Wires" data-point="Nav_Multiple_Wires" />
      </Branding>
      <Branding id="onetime_wire_abi22" value="true">
        <MobileNavMenuItem className="one-time-mobile-link" to="/oneTimeWireTransferWorkflow" label="One-Time Wire" data-point="Nav_One_Time_Wire" />
      </Branding>
      <Branding id="wire_activity_abi22" value="true">
        <MobileNavMenuItem className="wire-activity-mobile-link" to="/wiresActivity" label="Wire Activity" dataPoint="Nav_Wire_Activity" />
      </Branding>
    </MobileNavDropdownMenuItem>
  </Branding>

  let profileItem =   <MobileNavDropdownMenuItem className="profile-mobile-link" itemIcon={<SVGAsset id="CircleProfileIcon" />} label="Profile" dataPoint="Utility_Profile">
                        <Branding id="email_abi22" value="true">
                          <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "123" && val !== "1588"}>
                            <MobileNavMenuItem className="email-mobile-link" to="/email" label="Email Address" dataPoint="Utility_Email" />
                          </Branding>
                        </Branding>

                        <Branding id="email_abi22" value="true">
                          <Branding id="bid_abi22" value="Standard" exp={(val) => val == "123" || val == "1588"}>
                            <MobileNavMenuItem className="email-mobile-link" to="/email" label="Email" dataPoint="Utility_Email" />
                          </Branding>
                        </Branding>
                        <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "1702"}>
                        <DisabledPrompt>
                            <Branding id="tax_documents_abi22" value="true" default="false">
                              <MobileNavMenuItem className="tax-documents-mobile-link" label="Tax Documents" route="/taxDocuments" dataPoint="Utility_Tax_Documents"  />
                              </Branding>
                        </DisabledPrompt> 
                        </Branding>        
                        <Branding id="phone_abi22" value="true">
                          <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "123"} >
                            <MobileNavMenuItem className="phone-mobile-link" to="/phoneNumber" label="Phone" dataPoint="Utility_Phone" />
                          </Branding>
                        </Branding>
                        <Branding id="bid_abi22" value="Standard" exp={(val) => val == "123" } >
                        <DisabledPrompt>
                          <MobileNavMenuItem className="phone-numbers-mobile-link" to="/contactinformation" label="Phone Numbers" dataPoint="Utility_Contact_Information" />
                        </DisabledPrompt>
                        </Branding>
                        <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "1588" } >
                        <Branding id="address_abi22" value="true" default="true" >    
                        <DisabledPrompt>
                          <MobileNavMenuItem className="address-mobile-link" to="/address" label="Address" dataPoint="Utility_Address" />
                        </DisabledPrompt>
                        </Branding>
                        </Branding>
                        <MobileNavMenuItem className="password-mobile-link" to="/password" label="Password" dataPoint="Utility_Password" />
                        <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "123" } >
                          <Branding id="user_id_abi22" value="true">
                            <MobileNavMenuItem className="user-id-mobile-link" label="User ID" to="/userId" dataPoint="Utility_User_ID" />
                            <MobileNavMenuItem className="stopped-numbers-mobile-link" label="Stopped Numbers" to="/stoppedNumbers" dataPoint="Utility_Stopped_Numbers" />
                          </Branding>
                        </Branding>
                        <Branding id="bid_abi22" value="Standard" exp={(val) => val == "123" } >
                          <Branding id="user_id_abi22" value="true">
                            <MobileNavMenuItem className="stopped-numbers-mobile-link" label="Stopped Numbers" to="/stoppedNumbers" dataPoint="Utility_Stopped_Numbers" />
                            <MobileNavMenuItem className="user-id-mobile-link" label="User ID" to="/userId" dataPoint="Utility_User_ID" />                        
                          </Branding>
                        </Branding>
                        <Branding id="bid_abi22" value="Standard" exp={(val) => val === "1702"}>
                        <DisabledPrompt>
                            <Branding id="tax_documents_abi22" value="true" default="false">
                              <MobileNavMenuItem className="tax-documents-mobile-link" label="Tax Documents" route="/taxDocuments" dataPoint="Utility_Tax_Documents"  />
                              </Branding>
                        </DisabledPrompt> 
                        </Branding>                 
                      </MobileNavDropdownMenuItem>  


      let settingsItem = <MobileNavDropdownMenuItem className="settings-mobile-link"  itemIcon={<SVGAsset id="GearIcon" />} label="Settings" dataPoint="Utility_Settings">
                          { 
                            Util.inMabi && 
                            <MobileNavMenuItem className="authorized-device-enrollment-mobile-link" to="/authorizedDeviceEnrollmentWorkflow" label="Authorized Device Enrollment" dataPoint="Utility_Authorized_Device_Enrollment" /> 
                          }
  <BrandingDisabledIf id="notifi_version_abi22"  exp={(val) => val !== "Disabled" }>       
                          <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "123" && val !== "1588"} >  
                            <Branding id="alerts_abi22" value="true">
                              <MobileNavMenuItem className="alerts-mobile-link" to="/notifications" label="Alerts" dataPoint="Utility_Alerts" />
                            </Branding>
                          </Branding> 

                          <Branding id="bid_abi22" value="Standard" exp={(val) => val == "123" || val == "1588"} > 
                            <Branding id="alerts_abi22" value="true">
                              <MobileNavMenuItem className="advanced-alerts-mobile-link" to="/notifications" label="Advanced Alerts" dataPoint="Utility_Alerts" />
                            </Branding>
                          </Branding>
</BrandingDisabledIf>
                          <MobileNavMenuItem className="authorized-devices-alerts-mobile-link" to="/authorizedDevicesWorkflow" label="Authorized Devices" dataPoint="Utility_Authorized_Devices" />
                     
                          <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "123" } >
                            <Branding id="instant_balances_abi22" value="true">
                              <MobileNavMenuItem className="fast-balances-mobile-link" to="/settingsFastBalancesWorkflow" label="Fast Balances" dataPoint="Utility_Instance_Balances" />
                            </Branding>
                          </Branding> 

                          <Branding id="bid_abi22" value="Standard" exp={(val) => val == "123" } >
                            <Branding id="instant_balances_abi22" value="true">
                              <DisabledPrompt>
                                <MobileNavMenuItem className="instant-balances-mobile-link" to="/disabled" label="Instant Balances" dataPoint="Utility_Instance_Balances" />
                              </DisabledPrompt>
                            </Branding>
                          </Branding> 

                          <Branding id="text_banking_abi22" value="true">
                            <MobileNavSubDropdownMenuItem label="Text Banking" parentLabel="Settings" dataPoint="Utility_Text_Banking">
                              <MobileNavMenuItem className="mobile-nicknames-mobile-link" to="/mobileNicknamesWorkflow" label="Mobile Nicknames" dataPoint="Utility_Mobile_Nicknames" />
                              <MobileNavMenuItem className="text-banking-phone-list-mobile-link" to="/textbanking" label="Text Banking Phone List" dataPoint="Utility_Text_Banking_Phone_List" />
                              <MobileNavMenuItem className="register-phone-number-list-mobile-link" to="/textbanking" label="Register Phone Number" dataPoint="Utility_Register_Phone_Number" />
                            </MobileNavSubDropdownMenuItem>
                          </Branding>

                          <Branding id="authorized_apps_abi22" value="true">
                            <MobileNavMenuItem className="authorized-apps-mobile-link" to="/authorizedApps" label="Authorized Apps" dataPoint="Utility_Authorized_Apps" />
                          </Branding>
                          <Branding id="secure_forms_abi22" value="true" default="true">
                          <MobileNavMenuItem className="secure-forms-mobile-link" to="/secureforms" label="Secure Forms" dataPoint="Utility_Secure_Forms" />
                         </Branding>
                         <Branding id="bid_abi22" value="Standard">
                            <Branding id="users_abi22" value="true">
                              <MobileNavMenuItem className="users-mobile-link" to="/addUserWorkflow" label="Users" dataPoint="Utility_Users" />
                            </Branding>
                          </Branding>
                          <MobileNavMenuItem className="user-activity-mobile-link" to="/userActivityWorkflow" label="User Activity" dataPoint="Utility_User_Activity" />
                          <MobileNavMenuItem className="accepted-disclosures-mobile-link" to="/acceptedDisclosuresWorkflow" label="Accepted Disclosures" dataPoint="Utility_Accepted_Disclosures" />
                          <Branding id="delete_an_account_abi22" value="true" default="true">
                            <DisabledPrompt>
                              <MobileNavMenuItem className="delete-an-account-mobile-link" to="/deleteanaccount" label="Delete an Account" dataPoint="Utility_Delete_Account" />
                            </DisabledPrompt>
                          </Branding>
                         </MobileNavDropdownMenuItem>     
                         
  const hasMultiProfileOptionOn = options.multiprofile_abi22 === "true";
  let changeProfilePath = `/changeProfile`;

  // Use a try/catch here since this component is shared and 
  // "initAll" is not accessible in some of the login pages.
  try {
      const zelleProfile = Profile.initAll()[0];
      const zelleProfileID = zelleProfile.id;
      const defaultZelleProfileType = zelleProfile.type.toLowerCase();
      changeProfilePath = `/changeProfile/${ defaultZelleProfileType }/${zelleProfileID}`;
  } catch {}

  const zelleMobileNavItem = <MobileNavItem className="zle-mobile-link" itemIcon={ <SVGAsset id="ZelleIcon" /> } to={ hasMultiProfileOptionOn ? changeProfilePath : "/zelle" } label={<>Zelle<span className="r-mark">&reg;</span></>} dataPoint="Nav_Zelle" />

  let zleLinkEnabled = options.zle_courseID_abi22 === null ? false : true;
 
  // If option "How is Zelle presented?" is set to "CheckFree", 
  // but a "CheckFree" course id is not set, disable the "Zelle" link.
  if(options.present_zelle_abi22 === "CheckFree" && options.rxpmw_courseid_abi22 === null) {
      zleLinkEnabled = false;
  }

  const zleLink = zleLinkEnabled
  ? zelleMobileNavItem
  : <DisabledPrompt>{ zelleMobileNavItem }</DisabledPrompt>;

  const showStandardMenu = val => (
    val !== "123" && 
    val !== "1588" && 
    val !== "1224" && 
    val !== "126" &&
    val !== "932" &&
    val !== "2132P" &&
    val !== "2132B" &&
    val !== "1225B" &&
    val !== "1225P"
  );

  return (
    <MobileNavViewContext.Provider value={{ visible, setVisible }}>
      <CustomDrawer id="MobileNavView" className="mobile-nav-view show-on-mobile">
        <CustomDrawerHeader id="MobileNavView" dataPoint="Mobile_Nav_Header">
          <div className="flex-container flex-horizontal align-center">
            <div className="set-width">
              <UtilityNavBadge initials={ user.initials }/>
            </div>
            <div className="flex-width">
              <span className="user-name-text">{ username }</span>
            </div>
          </div>
        </CustomDrawerHeader>
        <CustomDrawerContent>
        <Branding id="bid_abi22" value="Standard" exp={ showStandardMenu } >   
       { newAccountsItem}
       <MobileNavDropdownMenuItem className="transfer-mobile-link"  itemIcon={<SVGAsset id="TransfersIcon" />}label="Transfers" dataPoint="Nav_Transfers">
            <MobileNavMenuItem className="make-a-transfer-mobile-link" to="/transfers" label="Make a Transfer" dataPoint="Nav_Make_Transfer" />
            <Branding id="transfer_templates_abi22" value="true">
              <MobileNavMenuItem className="transfer-templates-mobile-link" to="/addTransferTemplateWorkflow" label="Transfer Templates" dataPoint="Nav_Transfer_Templates" />
            </Branding>
            {(!Util.inMabi ) &&
              <Branding id="tn19_abi22" value="true">
              <BrandingDisabledIf id="tn19_courseID_abi22" exp={ value => value !== null }>
                <MobileNavMenuItem className="external-transfer-mobile-link" label="External Transfers" to="/externalTransfers" dataPoint="Nav_External_Transfers" />
              </BrandingDisabledIf>
            </Branding>
            }
            
            {(Util.inMabi && mabi23Branding.options.external_transfers_mabi23 !== "false") &&
            <BrandingDisabledIf id="tn19_courseID_abi22" exp={ value => value !== null }>
            <MobileNavMenuItem className="external-transfer-mobile-link" label="External Transfers" to="/externalTransfers" dataPoint="Nav_External_Transfers" />
          </BrandingDisabledIf>
          }  
            <MobileNavMenuItem className="transfer-activity-mobile-link" to="/transferActivity/scheduledTransfers" label="Transfer Activity" dataPoint="Nav_Transfer_Activity" />
            <Branding id="transfer_accounts_abi22" value="true">
              <MobileNavMenuItem className="transfer-activity-mobile-link" to="/unlinkedTransferAccounts" label="Transfer Accounts" dataPoint="Nav_Transfer_Accounts" />
            </Branding>
            <Branding id="native_external_accounts_abi22" value="true">
              <MobileNavMenuItem className="transfer-activity-mobile-link" to="/transferAccounts" label="Transfer Accounts" dataPoint="Nav_Transfer_External_Accounts" />
            </Branding>
            
            {/* <MobileNavMenuItem to="/transferAccountsWorkflow" label="Transfer Accounts" dataPoint="Nav_Transfer_Activity" /> */}
          </MobileNavDropdownMenuItem>
          {/* START: Branding the "Payments" item. */}
          <Branding id="rxp17_abi22" value="true">
            <Branding id="checkfree_mobile_version_abi22" value="CheckFree Mobile Web" exp={ val => val === "CheckFree Mobile Web" || val === "undefined" } >
              <BrandingDisabledIf id="rxpmw_courseid_abi22" exp={ value => value !== null }>
                <MobileNavItem className="rxpmw-mobile-link" itemIcon={ <SVGAsset id="DollarSignOutlineIcon" /> } label={ paymentsLabel } to="/rxpmw" dataPoint="Nav_Payments" />
              </BrandingDisabledIf>
            </Branding>
            <Branding id="checkfree_mobile_version_abi22" value="CheckFree Next">
              <BrandingDisabledIf id="rxp17_courseID_abi22" exp={ value => value !== null }>
                <MobileNavItem className="rxp17-mobile-link" itemIcon={ <SVGAsset id="DollarSignOutlineIcon" /> } label={ paymentsLabel } to="/rxpmw" dataPoint="Nav_Payments" />
              </BrandingDisabledIf>
            </Branding>
          </Branding>
          {/* END: Branding the "Payments" item. */}
          <Branding id="zle_abi22" value="true">
            { zleLink }
          </Branding>

          <Branding id="cards_abi22" value="true">
            <BrandingDisabledIf id="ch21_courseid_abi22" exp={ value => value !== undefined && value !== null }>
              { Util.inMabi && 
              <MobileNavItem className="ch21-mobile-link" itemIcon={ <SVGAsset id="CardIcon" /> } label="Cards" onClick={ onCardsClick } dataPoint="Nav_Cards" />
              }
              { !Util.inMabi && 
                <MobileNavItem className="ch21-mobile-link" itemIcon={ <SVGAsset id="CardIcon" /> } label="Cards" to="/ch21" dataPoint="Nav_Cards" />
              }
            </BrandingDisabledIf>
          </Branding>

       
          <Branding id="pfm21_abi22" value="true">
            <BrandingDisabledIf id="pfm21_courseID_abi22" exp={ value => value !== null } >
              <MobileNavItem className="pfm21-mobile-link" itemIcon={ <SVGAsset id="WalletIcon" /> } label="My Finances" to="/myFinances" dataPoint="Nav_My_Finances" />
            </BrandingDisabledIf>
          </Branding>

          {!Util.inMabi &&( options.deposits_abi22 =="true" ?<Branding id="deposits_nav_abi22" value="true">        
            <MobileNavDropdownMenuItem className="deposits-mobile-link"  itemIcon={<SVGAsset id="CameraIcon" />} label="Deposits" dataPoint="Nav_Deposits">
            <Branding id="deposits_abi22" value="true">
               <MobileNavMenuItem className="deposit-history-link"  to="/depositHistory" label="Deposit History" dataPoint="Nav_Deposit_History" /></Branding>
            </MobileNavDropdownMenuItem>           
          </Branding>  : <Branding id="deposits_nav_abi22" value="true"> <DisabledPrompt> <MobileNavDropdownMenuItem className="deposits-mobile-link"  itemIcon={<SVGAsset id="CameraIcon" />} label="Deposits" dataPoint="Nav_Deposits">  </MobileNavDropdownMenuItem></DisabledPrompt></Branding>
         )
          }
          {(Util.inMabi && mabi23Branding.options.deposits_side_nav_mabi23 === "true") &&( mabi23Branding.options.side_nav_mobile_deposit_mabi23 === "true"||mabi23Branding.options.deposit_history_mabi23 =="true"?<MobileNavDropdownMenuItem className="deposits-mobile-link"  itemIcon={<SVGAsset id="CameraIcon" />} label="Deposits" dataPoint="Nav_Deposits">
            { mabi23Branding.options.side_nav_mobile_deposit_mabi23 === "true" && <MobileNavMenuItem to="/depositACheckWorkflow" label="Deposit a Check" dataPoint="Nav_Deposit_A_Check" /> }
            { mabi23Branding.options.deposit_history_mabi23 === "true" && <MobileNavMenuItem className="deposit-history-link"  to="/depositHistory" label="Deposit History" dataPoint="Nav_Deposit_History" />}
          </MobileNavDropdownMenuItem>  :( <DisabledPrompt> <MobileNavDropdownMenuItem className="deposits-mobile-link"  itemIcon={<SVGAsset id="CameraIcon" />} label="Deposits" dataPoint="Nav_Deposits">  </MobileNavDropdownMenuItem></DisabledPrompt>)
           )      
        }
        {/*
        </CustomDrawerContent>
          <Branding id="documents_abi22" value="true">
           {documentsItem}
          </Branding>


          <Branding id="deposits_abi22" value="true">
            <MobileNavDropdownMenuItem itemIcon={<SVGAsset id="CameraIcon" />} label="Deposits" dataPoint="Nav_Deposits">
              <MobileNavMenuItem to="/depositHistory" label="Deposit History" dataPoint="Nav_Deposit_History" />
            </MobileNavDropdownMenuItem>
          </Branding>
       */}
        {achItem}
        {wireLinks}
        {profileItem}
         {settingsItem} 

         <Branding id="messages_abi22" value="true" default="true">
          <MobileNavItem className="messages-mobile-link" to="/messages" label="Messages" itemIcon={<SVGAsset id="EnvelopeIcon" />} dataPoint="Nav_Messages">
            <div className="set-width alert-bubble flex-container all-center">
              <span>3</span>
            </div>
          </MobileNavItem>
         </Branding>
         { mabi23BrandingOptions.secure_mail_mabi23 === "true" && 
          <DisabledPrompt>
            <MobileNavItem className="mail-mobile-link" to="" label="Mail" itemIcon={<SVGAsset id="EnvelopeIcon" />} dataPoint="Nav_Mail" />
          </DisabledPrompt>
         }

         { Util.inMabi && mabi23BrandingOptions.chat_mabi23 === "true" && <MobileNavItem className="chat-mobile-link" onClick={ chatLink } label="Chat" itemIcon={<SVGAsset id="ChatIcon" />} dataPoint="Nav_Chat" /> }
         
         { !Util.inMabi && 
          <Branding id="chat_abi22" value="true">
            <MobileNavItem className="chat-mobile-link" onClick={ chatLink } label="Chat" itemIcon={<SVGAsset id="ChatIcon" />} dataPoint="Nav_Chat" />
          </Branding>
         }
          
   </Branding>
   
   {/* Using bid 1224 specific component to reduce the amount of code used in this file. */}
   {/*NOTE: If the items in the profile/settings change significantly for bid 1224,
  you may want to declare and use separate ones in component "BID1224MobileNavView". */}
   <BID1224MobileNavItems items={{
    //settings: settingsItem
   }}/>

   <BID126MobileNavItems/>

   <Branding id="bid_abi22" value="123" >
          { accountsItem}
          <Branding id="rxp17_abi22" value="true">
            <BrandingDisabledIf id="rxpmw_courseid_abi22" exp={ value => value !== null }>
              <MobileNavItem className="rxpmw-mobile-link" itemIcon={ <SVGAsset id="DollarSignOutlineIcon" /> } label={ paymentsLabel } to="/rxpmw" dataPoint="Nav_Payments" />
            </BrandingDisabledIf>
          </Branding>
          <Branding id="zle_abi22" value="true">
            { zleLink }
          </Branding>

       <MobileNavDropdownMenuItem className="transfer-mobile-link"  itemIcon={<SVGAsset id="TransfersIcon" />}label="Transfers" dataPoint="Nav_Transfers">
            <MobileNavMenuItem className="make-a-transfer-mobile-link" to="/transfers" label="Make a Transfer" dataPoint="Nav_Make_Transfer" />
           
            <Branding id="tn19_abi22" value="true">
              <BrandingDisabledIf id="tn19_courseID_abi22" exp={ value => value !== null }>
                <MobileNavMenuItem className="external-transfer-mobile-link" label="External Transfers" to="/externalTransfers" dataPoint="Nav_External_Transfers" />
              </BrandingDisabledIf>
            </Branding>
            <MobileNavMenuItem className="transfer-activity-mobile-link" to="/transferActivity/scheduledTransfers" label="Transfer Activity" dataPoint="Nav_Transfer_Activity" />
 
            <Branding id="transfer_accounts_abi22" value="true">
              <MobileNavMenuItem className="transfer-activity-mobile-link" to="/unlinkedTransferAccounts" label="Transfer Accounts" dataPoint="Nav_Transfer_Accounts" />
            </Branding>
            <Branding id="native_external_accounts_abi22" value="true">
              <MobileNavMenuItem className="transfer-activity-mobile-link" to="/transferAccounts" label="Transfer Accounts" dataPoint="Nav_Transfer_External_Accounts" />
            </Branding>

          </MobileNavDropdownMenuItem>
          
          <Branding id="cards_abi22" value="true">
            <BrandingDisabledIf id="ch21_courseid_abi22" exp={ value => value !== undefined && value !== null }>
              <MobileNavItem className="ch21-mobile-link" itemIcon={ <SVGAsset id="CardIcon" /> } label="Cards" onClick={ onCardsClick } dataPoint="Nav_Cards" />
            </BrandingDisabledIf>
          </Branding>

       
          <Branding id="pfm21_abi22" value="true">
            <BrandingDisabledIf id="pfm21_courseID_abi22" exp={ value => value !== null } >
              <MobileNavItem className="pfm21-mobile-link" itemIcon={ <SVGAsset id="WalletIcon" /> } label="My Finances" to="/myFinances" dataPoint="Nav_My_Finances" />
            </BrandingDisabledIf>
          </Branding>

        {/*
        </CustomDrawerContent>
          <Branding id="documents_abi22" value="true">
           {documentsItem}
          </Branding>


          <Branding id="deposits_abi22" value="true">
            <MobileNavDropdownMenuItem itemIcon={<SVGAsset id="CameraIcon" />} label="Deposits" dataPoint="Nav_Deposits">
              <MobileNavMenuItem to="/depositHistory" label="Deposit History" dataPoint="Nav_Deposit_History" />
            </MobileNavDropdownMenuItem>
          </Branding>
       */}
        {profileItem}
         {settingsItem} 

         <Branding id="messages_abi22" value="true" default="true">
          <MobileNavItem className="messages-mobile-link" to="/messages" label="Messages" itemIcon={<SVGAsset id="EnvelopeIcon" />} dataPoint="Nav_Messages">
            <div className="set-width alert-bubble flex-container all-center">
              <span>3</span>
            </div>
          </MobileNavItem>
         </Branding>

          <Branding id="chat_abi22" value="true">
            <MobileNavItem className="chat-mobile-link" onClick={ chatLink } label="Chat" itemIcon={<SVGAsset id="ChatIcon" />} dataPoint="Nav_Chat"/>
          </Branding>
     </Branding>

             
     <Branding id="bid_abi22" value="1588"  >
          { accountsItem}
          <Branding id="rxp17_abi22" value="true">
            <BrandingDisabledIf id="rxpmw_courseid_abi22" exp={ value => value !== null }>
              <MobileNavItem className="rxpmw-mobile-link" itemIcon={ <SVGAsset id="DollarSignOutlineIcon" /> } label={ paymentsLabel } to="/rxpmw" dataPoint="Nav_Payments" />
            </BrandingDisabledIf>
          </Branding>


          <Branding id="cards_abi22" value="true">
            <BrandingDisabledIf id="ch21_courseid_abi22" exp={ value => value !== undefined && value !== null }>
              <MobileNavItem className="ch21-mobile-link" itemIcon={ <SVGAsset id="CardIcon" /> } label="Cards" onClick={ onCardsClick } dataPoint="Nav_Cards" />
            </BrandingDisabledIf>
          </Branding>
          <Branding id="zle_abi22" value="true">
            { zleLink }
          </Branding>
       <MobileNavDropdownMenuItem className="transfer-mobile-link"  itemIcon={<SVGAsset id="TransfersIcon" />}label="Transfers" dataPoint="Nav_Transfers">
            <MobileNavMenuItem className="make-a-transfer-mobile-link" to="/transfers" label="Make a Transfer" dataPoint="Nav_Make_Transfer" />
            <MobileNavMenuItem className="transfer-activity-mobile-link" to="/transferActivity/scheduledTransfers" label="Transfer Activity" dataPoint="Nav_Transfer_Activity" />

            <Branding id="tn19_abi22" value="true">
              <BrandingDisabledIf id="tn19_courseID_abi22" exp={ value => value !== null }>
                <MobileNavMenuItem className="external-transfers-mobile-link" label="External Transfers" to="/externalTransfers" dataPoint="Nav_External_Transfers" />
              </BrandingDisabledIf>
            </Branding>

            <Branding id="transfer_accounts_abi22" value="true">
              <MobileNavMenuItem className="transfer-activity-mobile-link" to="/unlinkedTransferAccounts" label="Transfer Accounts" dataPoint="Nav_Transfer_Accounts" />
            </Branding>
            <Branding id="native_external_accounts_abi22" value="true">
              <MobileNavMenuItem className="transfer-activity-mobile-link" to="/transferAccounts" label="Transfer Accounts" dataPoint="Nav_Transfer_External_Accounts" />
            </Branding>

          </MobileNavDropdownMenuItem>
         

       
          <Branding id="pfm21_abi22" value="true">
            <BrandingDisabledIf id="pfm21_courseID_abi22" exp={ value => value !== null } >
              <MobileNavItem className="pfm21-mobile-link" itemIcon={ <SVGAsset id="WalletIcon" /> } label="My Finances" to="/myFinances" dataPoint="Nav_My_Finances" />
            </BrandingDisabledIf>
          </Branding>

        {/*
        </CustomDrawerContent>
          <Branding id="documents_abi22" value="true">
           {documentsItem}
          </Branding>


          <Branding id="deposits_abi22" value="true">
            <MobileNavDropdownMenuItem itemIcon={<SVGAsset id="CameraIcon" />} label="Deposits" dataPoint="Nav_Deposits">
              <DisabledPrompt>
                <MobileNavMenuItem to="/disabled" label="Deposit a Check" dataPoint="Deposit_a_Check" />
              </DisabledPrompt>
              <MobileNavMenuItem to="/depositHistory" label="Deposit History" dataPoint="Nav_Deposit_History" />

              <Branding id="msc_abi22" value="true">
                  <BrandingDisabledIf id="msc_id_abi22" exp={ value => value !== null && value !== undefined }>
                    <MobileNavMenuItem label="Merchant Source Capture" dataPoint="Nav_Merchant_Source_Capture" onClick={ openMerchant } />
                  </BrandingDisabledIf>
              </Branding>
            </MobileNavDropdownMenuItem>
          </Branding>
       */}
        {profileItem}
         {settingsItem} 

         <Branding id="messages_abi22" value="true" default="true">
          <MobileNavItem className="messages-mobile-link" to="/messages" label="Messages" itemIcon={<SVGAsset id="EnvelopeIcon" />} dataPoint="Nav_Messages">
            <div className="set-width alert-bubble flex-container all-center">
              <span>3</span>
            </div>
          </MobileNavItem>
         </Branding>

          <Branding id="chat_abi22" value="true">
            <MobileNavItem className="chat-mobile-link" onClick={ chatLink } label="Chat" itemIcon={<SVGAsset id="ChatIcon" />} dataPoint="Nav_Chat" />
          </Branding>
    </Branding>

        <BID932MobileNavItems />
        <BID2132PMobileNavItems />
        <BID2132BMobileNavItems />
        <BID1225BMobileNavItems />
        <BID1225PMobileNavItems />
    
        </CustomDrawerContent>
       
        <CustomDrawerFooter>
          <ModalSecondaryButton text="Log Out" onClick={logout} dataPoint="Nav_Logout"/>
        </CustomDrawerFooter>
      </CustomDrawer>
    </MobileNavViewContext.Provider>
  );
}

const useMobileNavViewContext = () => React.useContext(MobileNavViewContext);

/**
 * @function MobileNavItem
 * @exported false
 * @description - This is the main navigation item.
 * @param {STRING} itemIcon - Sets the main navigation item left icon.
 * @param {STRING} label - Sets the label of the main navigation item.
 * @param {React.Component} children - Allows us to inject content/components into the MobileNavItem, usually an arrow for accordions.
 * @example
 * <MobileNavView>
 *  <MobileNavItem itemIcon={<SVGAsset id="ChatIcon" />} label="Chat">
 *     <div className="set-width accordion-icon-container">
          <SVGAsset id="DownChevronIcon" />
        </div>
 *  </MobileNavItem>
 * </MobileNavView>
 */
export function MobileNavItem(props){
  const itemIcon = props.itemIcon ?? null;
  const label = props.label ?? "[menu item]";
  const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};
  const className = props.className ?? "";

  return (
    <NavLink className={className} to={ props.to } onClick={ props.onClick }>
      <div className="mobile-nav-view-item flex-container flex-horizontal align-center">
        <div className="icon-container set-width flex-container all-center">
          {itemIcon}
        </div>

        <div className="flex-width text-container">
          <span { ...dataPoint }>{label}</span>
        </div>

        {props.children}
      </div>
    </NavLink>
  );
}

/**
 * @function MobileNavDropdownMenuItem
 * @exported false
 * @description - The menu item that serves as the accordion toggle.
 * @param {STRING} itemIcon - This is passed from the MobileNavItem, allows to set the left icon of the menu item.
 * @param {STRING} label - This is passed from the MobileNavItem, allows to set the label of the menu item.
 * @param {React.Component} children - Allows us to pass content/components, will always pass MobileNavMenuItems.
 * @example
 * <MobileNavView>
 *  <MobileNavDropdownMenuItem itemIcon={<SVGAsset id="GearIcon" />} label="Settings">
 *    <MobileNavMenuItem to="/accountSummary" label="Account Summary" />
 *  </MobileNavDropdownMenuItem>
 * </MobileNavView>
 */
export function MobileNavDropdownMenuItem(props){
  const { visible, setVisible } = useMobileNavViewContext();
  const [ state, setState ] = useState(visible === props.label);

  const onClick = value => setVisible(value ? props.label : "");
  useEffect(() => setState(visible === props.label), [ visible ]);

  return (
    <CustomAccordion activeClass="open-menu-accordion" isOpen={ state }>
      <CustomAccordionToggle onClick={ onClick }>
        <MobileNavItem {...props}>
          <div className="set-width accordion-icon-container">
            <SVGAsset id={ state ? "UpChevronIcon" : "DownChevronIcon" } />
          </div>
        </MobileNavItem>
      </CustomAccordionToggle>

      <CustomAccordionContent>
        {props.children}
      </CustomAccordionContent>
    </CustomAccordion>
  );
}

/**
 * @function MobileNavSubDropdownMenuItem
 * @param {STRING} label - The label of the dropdown item
 * @param {STRING} parentLabel - The label of the parent dropdown
 * @param {STRING} dataPoint - The data point that should be added
 * @returns {React.Component}
 * @description A sub dropdown component
 * @example
 * <MobileNavSubDropdownMenuItem label="Label" parentLabel="parentLabel" />
 */
export function MobileNavSubDropdownMenuItem(props) {
  const { visible } = useMobileNavViewContext();
  const [ state, setState ] = useState(false);

  const onClick = value => setState(value);
  useEffect(() => setState(props.parentLabel !== visible ? false : state), [ visible ]);

  return (
    <CustomAccordion activeClass="open-menu-accordion" isOpen={ state }>
      <CustomAccordionToggle onClick={ onClick }>
        <MobileNavItem {...props}>
          <div className="set-width accordion-icon-container">
            <SVGAsset id={ state ? "UpChevronIcon" : "DownChevronIcon" } />
          </div>
        </MobileNavItem>
      </CustomAccordionToggle>

      <CustomAccordionContent>
        {props.children}
      </CustomAccordionContent>
    </CustomAccordion>
  );
}

/**
 * @function MobileNavMenuItem
 * @exported false
 * @description - The menu item inside of an accordion.
 * @param {STRING} to - Sets the route.
 * @param {STRING} label - Sets the label of the item.
 * @example
 * <MobileNavDropdownMenuItem itemIcon={<SVGAsset id="GearIcon" />} label="Settings">
 *  <MobileNavMenuItem to="/accountSummary" label="Account Summary" />
 * </MobileNavDropdownMenuItem>
 */
export function MobileNavMenuItem(props){
  const className = props.className ?? "";
  const to = props.to ?? "";
  const label = props.label ?? "";
  const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};

  return (
    <NavLink className={className} to={ to } onClick={ props.onClick }>
      <div className="flex-height mobile-nav-menu-item">
        <span className="mobile-nav-menu-item-label" { ...dataPoint }>
          { label }
        </span>
      </div>
    </NavLink>
  );
}